<!-- Hourly Activity Chart -->
<div class="bg-white dark:bg-slate-800 rounded-2xl p-6 shadow-sm dark:shadow-slate-900/30 border border-gray-100 dark:border-slate-700">
  <!-- Header -->
  <div class="flex items-center justify-between mb-6">
    <div class="flex items-center gap-2">
      <span class="text-2xl">📈</span>
      <h3 class="text-lg font-bold text-gray-800 dark:text-gray-100">Activité par heure</h3>
    </div>
    @if (summary) {
      <div class="flex items-center gap-4 text-sm">
        <div class="flex items-center gap-1">
          <span
            class="w-3 h-3 rounded-full bg-gradient-to-t from-indigo-600 to-purple-500"
          ></span>
          <span class="text-gray-600 dark:text-gray-400">Heures de pointe</span>
        </div>
      </div>
    }
  </div>

  <!-- Loading State -->
  @if (isLoading) {
    <div
      class="h-48 flex items-end justify-between gap-1 animate-pulse"
      >
      @for (h of [30, 50, 40, 70, 45, 60, 35, 80, 55, 65, 40, 50]; track h) {
        <div
          class="bg-gray-200 dark:bg-slate-700 rounded-t-lg flex-1"
          [style.height.%]="h"
        ></div>
      }
    </div>
  }

  <!-- Error State -->
  @if (error && !isLoading) {
    <div class="text-center py-12">
      <span class="text-3xl mb-2 block">⚠️</span>
      <p class="text-gray-500 dark:text-gray-400">{{ error }}</p>
    </div>
  }

  <!-- Chart -->
  @if (!isLoading && !error) {
    <div #chartContainer class="relative">
      <!-- Barres -->
      <div class="h-48 flex items-end gap-1 mb-2">
        @for (hour of hourlyData; track hour) {
          <div
            class="flex-1 h-full relative group cursor-pointer flex items-end"
            [title]="formatHour(hour.hour) + ' - ' + formatCurrency(hour.revenue)"
            >
            <!-- Barre -->
            <div
              class="w-full rounded-t-lg transition-all duration-300 hover:opacity-80"
              [ngClass]="getBarColor(hour.hour, hour.isPeak)"
              [style.height]="getBarHeight(hour.revenue)"
            ></div>
            <!-- Tooltip on hover -->
            <div
              class="absolute bottom-full left-1/2 -translate-x-1/2 mb-2 px-2 py-1 bg-gray-900 text-white text-xs rounded opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap pointer-events-none z-10"
              >
              <div class="font-medium">{{ formatHour(hour.hour) }}</div>
              <div>{{ formatCurrency(hour.revenue) }}</div>
              <div>{{ hour.salesCount }} ventes</div>
              @if (hour.isPeak) {
                <div class="text-yellow-300">
                  ⭐ Heure de pointe
                </div>
              }
            </div>
          </div>
        }
      </div>
      <!-- Axe X - Heures -->
      <div class="flex gap-1">
        @for (hour of hourlyData; track hour; let i = $index) {
          @if (i % 2 === 0) {
            <div
              class="flex-1 text-center text-xs text-gray-500 dark:text-gray-400"
              >
              {{ formatHour(hour.hour) }}
            </div>
          }
          @if (i % 2 !== 0) {
            <div class="flex-1"></div>
          }
        }
      </div>
      <!-- Summary -->
      @if (summary) {
        <div
          class="mt-6 pt-4 border-t border-gray-100 dark:border-slate-700 grid grid-cols-3 gap-4"
          >
          <div class="text-center">
            <p class="text-2xl font-bold text-gray-900 dark:text-white">{{ summary.totalSales }}</p>
            <p class="text-xs text-gray-500 dark:text-gray-400">Ventes totales</p>
          </div>
          <div class="text-center">
            <p class="text-2xl font-bold text-indigo-600">
              {{ formatCurrency(summary.totalRevenue) }}
            </p>
            <p class="text-xs text-gray-500 dark:text-gray-400">CA total</p>
          </div>
          <div class="text-center">
            <p class="text-2xl font-bold text-gray-900 dark:text-white">{{ getPeakHoursText() }}</p>
            <p class="text-xs text-gray-500 dark:text-gray-400">Heures de pointe</p>
          </div>
        </div>
      }
    </div>
  }
</div>
